import React from 'react';
import { SESSION_TYPES } from '@medflex/utils/constants';
import GroupIcon from '@medflex/components/stories/GroupAvatar/GroupIcon';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import isTeamChatId from '@medflex/utils/isTeamChatId';

const mapSessionChatToContact =
  ({ userId, teamSubTitle }) =>
  sessionChat => {
    const {
      participants,
      title,
      id,
      type,
      messageLastAt,
      messageLastReadId,
      messagesUnreadCount,
      messagesMarkedAsImportant,
      createdAt,
      deactivated,
    } = sessionChat;
    const participantsButMe = participants.filter(participant => participant.userId !== userId);

    const participantsString = participantsButMe
      .map(participant => getFullNameWithTitle(participant))
      .join('; ');

    const fullNameWithTitle = title || participantsString;
    const isTeamChat = isTeamChatId(id);

    return {
      id,
      user: {
        id: type === SESSION_TYPES.INTERNAL1ON1 ? participantsButMe[0].userId : id,
        avatar: type !== SESSION_TYPES.INTERNAL1ON1 && <GroupIcon />,
        initials:
          type === SESSION_TYPES.INTERNAL1ON1
            ? `${participantsButMe[0].firstName[0]}${participantsButMe[0].lastName[0]}`
            : 'G',
        fullNameWithTitle,
        ...(title && { subtitle: participantsString }),
        ...(isTeamChat && { subtitle: teamSubTitle }),
        // save participantsString as workplace only of not only saved as title above
        ...(title && { workplace: participantsString }),
        deactivated,
      },
      messages: {
        lastAt: messageLastAt,
        lastReadId: messageLastReadId,
        unread: messagesUnreadCount || 0,
      },
      ...(messagesMarkedAsImportant && {
        messagesMarkedAsImportant,
      }),
      enabled: true,
      isTeamChat,
      createdAt,
      pairedAt: createdAt,
      type: [SESSION_TYPES.TEAM_CHAT, SESSION_TYPES.INTERNAL1ON1].includes(type)
        ? 'team-chat'
        : 'session-chat',
      _dateSort: new Date(messageLastAt || createdAt).getTime(),
      _nameSort: fullNameWithTitle.toUpperCase(),
    };
  };

export default mapSessionChatToContact;
